import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Accordion, Button, Col, Form, Image, InputGroup, Modal, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import toast from "react-hot-toast";
import { AiFillCheckCircle, AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { FaPhone, FaQuestion, FaWhatsapp } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { LoadCanvasTemplate, loadCaptchaEnginge, validateCaptcha } from "react-simple-captcha";
import B2bForumFlow from "../../../assets/b2bImages/b2bForumFlowChart.png";
import collaborationRegisterQR from "../../../assets/collaborationRegisterQR.png";
import infoImg from "../../../assets/infoimg.png";
import Layout from "../../../components/Layouts/Layouts/Layout";
import OurPresence from "../../../components/b2b/OurPresence";
import EPlatformHeader from "../../../components/basic/EPlatformHeader";
import { getURLbyEndPoint } from "../../../store/api";
import { country_list, role } from "../../auth/Register/AllRegiPageLists";
import "../../auth/Register/Register.css";
import { Profession } from "../../sideBarPage/EventsPages/B2bEventRequest";
import ContactTable from "../../../components/b2b/ContactTable";

const CollaborationSignup = () => {
  const [registerFormSuccess, setRegisterFormSuccess] = useState(false);
  const [captchaValue, setCaptchaValue] = useState("");
  const [isCaptchaCorrect, setIsCaptchaCorrect] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [validated, setValidated] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const captcha_length = 6;

  const initialFormData = {
    selectMembership: "Collaboration",
    companyName: "",
    businessCategory: "",
    inputNumber: "",
    gstNo: "",
    address1: "",
    address2: "",
    city: "",
    country: "",
    state: "",
    pinCode: "",
    firstName: "",
    surName: "",
    role: "",
    email: "",
    password: "",
    phoneNo: "",
    telephoneNo: "",
    reqType: "collaborationReq",
    isExisting: true,
    isTrial: false,
  };

  const [formData, setFormData] = useState(initialFormData);
  const [showModal, setShowModal] = useState(false);
  const [showFaqModal, setShowFaqModal] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const checkboxRef = useRef(null);

  const handleShow = () => setShowModal(true);
  const handleShowFaq = () => setShowFaqModal(true);
  const handleClose = () => setShowModal(false);
  const handleCloseFaq = () => setShowFaqModal(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleConfirmChange = (e) => {
    const { value } = e.target;
    setConfirmPassword(value);
  };

  const handleCaptchaChange = (evt) => {
    setCaptchaValue(evt.target.value);
    if (validateCaptcha(evt.target.value, false)) {
      setIsCaptchaCorrect(true);
      return;
    }
    setIsCaptchaCorrect(false);
  };

  const handleAgree = () => {
    setIsChecked(true);
    if (checkboxRef.current) {
      checkboxRef.current.checked = true;
    }
    handleClose();
  };

  const resetForm = () => {
    setFormData(initialFormData);
    setCaptchaValue("");
    setIsCaptchaCorrect(false);
    setRegisterFormSuccess(false);
    setValidated(false);
    setIsChecked(false);
  };

  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*\d)(?=.*[A-Z]?)(?=.*[!@#$%^&*()_+[\]{}|;:',.<>?~\\/-]).{8,15}$/;
    return passwordRegex.test(password);
  };

  const handleRegiFormSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false || !isCaptchaCorrect) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    if (!validatePassword(formData.password)) {
      toast.error("Password must be 8-15 characters, contain at least one lowercase letter, one number, and may include one uppercase letter and one special character.");
      return;
    }

    if (formData.password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    setRegisterFormSuccess(true);

    try {
      formData.phoneNo = parseInt(formData.phoneNo);
      formData.pinCode = parseInt(formData.pinCode);

      const res = await axios.post(getURLbyEndPoint("createClient"), formData);

      if (res?.data?.status) {
        alert("Form submitted successfully. Please wait for the B2B team to confirm your registration. Thank you!");
        setRegisterFormSuccess(false);
        setFormData(initialFormData);
        window.location.reload()
      } else {
        toast.error(res?.data?.message || "An error occurred");
      }
    } catch (e) {
      console.error("Error caught:", e);
      toast.error(e?.response?.data?.message || "An error occurred");
    } finally {
      setRegisterFormSuccess(false);
    }
  };



  useEffect(() => {
    loadCaptchaEnginge(captcha_length);
  }, []);

  return (
    <>
      <Layout>
        <EPlatformHeader heading="Collaborator Sign-up Form" text="Explore Business Opportunities and Resources by Signing Up with e-Platform" />
        <div className="custom-width mx-auto my-4">
          <Row className="mt-2">
            <Col sm={12} lg={6} className="mb-4">
              <div className="fw-bold fs-3">Welcome to e-Platform</div>
              <div className="fw-semibold mt-2">
                To ensure a seamless experience and keep you well-informed about the various activities being undertaken by AECCI, we kindly request that you sign up through our e-platform.
              </div>
              <div className="fw-semibold mt-2">
                By signing up for our e-platform, you’ll be able to engage with a variety of business opportunities and resources to enhance the collaboration.
              </div>

              <div className="fw-bold mt-4 mb-2">Signing-up will enable you to:</div>
              <ul>
                <li>Gain visibility by creating your profile.</li>
                <li>View the signed cooperation agreements and download Certificate of Collaboration.</li>
                <li>Connect one-to-one with our business participants in our exclusive virtual B2B Forum and explore new international businesses.</li>
              </ul>
              <div className="fw-bold mt-4 mb-2">By Signing-up the e-Platform, You’ll Get Access To Our Virtual B2B Forum:</div>
              <ul>
                <li><span className="fw-semibold">To Schedule your meetings:</span> Easily set your availability for meetings and receive appointment requests from Indian business participants based on your time slots.</li>
                <li><span className="fw-semibold">Business Profiles:</span> You can view the list and profile of the businesses interested in trade opportunities in your country.</li>
                <li><span className="fw-semibold">Probable Points of Discussion:</span> You can also see the probable points of discussion that participants may ask during the b2b sessions.</li>
              </ul>

              <h5 className="fw-semibold mt-4">If you need any further assistance, feel free to contact our B2B team at:</h5>
              <Row className="mt-3">
                <Col md={4} xs={12} className="text-center">
                  <div className='flex flex-col d-none d-md-block'>
                    <img src={collaborationRegisterQR} className="img-fluid w-75 mt-3" alt="Register QR" />
                    <Button onClick={handleShowFaq} variant="outline-info" className='mt-2'>Read FAQs <FaQuestion /></Button>
                  </div>
                </Col>
                <Col md={8} xs={12}>
                  <div className="d-flex align-items-start gap-2 my-2">
                    <div>
                      <strong>Virtual B2B Forum Sales & Marketing Head</strong>
                      <div className="fw-semibold">Executive Director - Mrs. Swarn Dhiman </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-start gap-2 my-2">
                    <FaWhatsapp size={20} />
                    <div className="fw-semibold">
                      WhatsApp: <a href="https://wa.me/918433720996" className="text-decoration-none">+91-8433720996</a>
                    </div>
                  </div>
                  <div className="d-flex align-items-start gap-2 my-2">
                    <FaPhone size={20} style={{ transform: "rotate(90deg)" }} />
                    <div className="fw-semibold">
                      Board lines: <a href="tel:+912241271145" className="text-decoration-none">+91-22-41271145 | 46 | 47</a>
                    </div>
                  </div>

                  <div className="d-flex align-items-start gap-2 my-2">
                    <MdEmail size={20} />
                    <div className="fw-semibold">
                      Email: <a href="mailto:ed@aecci.org.in" className="text-decoration-none">ed@aecci.org.in</a>
                    </div>
                  </div>
                  <div className="d-flex align-items-start gap-2 my-2">
                    <div className="fw-semibold">
                      Monday – Friday: 9.30 am – 6.30 pm*<br />
                      Saturday – 9.30 am – 3.30 pm* (IST)<br />
                    </div>
                  </div>

                </Col>
              </Row>
              <div>
                <div className='flex flex-col d-none d-md-block'>
                  <img src={B2bForumFlow} className="img-fluid w-100 mt-3" alt="VirtualB2bForum" />
                </div>
              </div>
            </Col>
            <Col sm={12} lg={6}>
              <div className="text-white montserratFont" style={{ background: "#021C43", padding: "20px" }}>
                <Form noValidate validated={validated} onSubmit={handleRegiFormSubmit}>
                  <p className="mt-4" style={{ fontSize: "0.9em" }}>
                    <span className="fs-6 fw-semibold">
                      fill all fields as per AECCI records
                    </span>
                    <br />* indicates required fields
                  </p>
                  <div className="my-4">
                    <Row>
                      <Col xs={12} sm={12} lg={12}>
                        <label
                          className="fw-bold"
                          style={{ fontSize: "1rem" }}
                        >
                          Email Address *
                        </label>
                        <div className="d-flex flex-column">
                          <input
                            style={{ width: "100%", height: "auto" }}
                            className="form-control rounded-0"
                            onChange={handleInputChange}
                            value={formData.email}
                            name="email"
                            type="email"
                            maxLength={40}
                            required
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="my-4">
                    <Row>
                      <Col xs={12} sm={6} lg={6}>
                        <Form.Group>
                          <Form.Label className="fw-bold" style={{ fontSize: "1rem" }}>Password *</Form.Label>
                          <InputGroup>
                            <Form.Control
                              type={showPassword ? "text" : "password"}
                              name="password"
                              value={formData.password}
                              onChange={handleInputChange}
                              required
                              maxLength={15}
                            />
                            <Button
                              variant="outline-secondary"
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              {showPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
                            </Button>
                            <Form.Control.Feedback type="invalid">
                              Please enter a valid password
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6} lg={6}>
                        <Form.Group>
                          <Form.Label className="fw-bold" style={{ fontSize: "1rem" }}>Confirm Password *</Form.Label>
                          <InputGroup>
                            <Form.Control
                              type={showConfirmPassword ? "text" : "password"}
                              name="confirmPassword"
                              value={confirmPassword}
                              onChange={handleConfirmChange}
                              required
                              maxLength={15}
                            />
                            <Button
                              variant="outline-secondary"
                              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            >
                              {showConfirmPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
                            </Button>
                            <Form.Control.Feedback type="invalid">
                              Passwords must match
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>

                  <div className="my-4">
                    <Row>
                      <Col md={12}>
                        <div>
                          <label
                            className="fw-bold"
                            style={{ fontSize: "1rem" }}
                          >
                            Company / Organization Name *
                          </label>
                          <div className="d-flex flex-column">
                            <input
                              style={{ width: "100%", height: "auto" }}
                              className="form-control rounded-0"
                              onChange={handleInputChange}
                              value={formData.companyName}
                              name="companyName"
                              type="text"
                              maxLength={50}
                              required
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="my-4">
                    <Row>
                      <Col xs={12} sm={6} lg={6}>
                        <label
                          className="fw-bold"
                          style={{ fontSize: "1rem" }}
                        >
                          First Name *{" "}
                        </label>
                        <div className="d-flex flex-column">
                          <input
                            style={{ width: "100%", height: "auto" }}
                            className="form-control rounded-0"
                            onChange={handleInputChange}
                            value={formData.firstName}
                            name="firstName"
                            type="text"
                            maxLength={30}
                            required
                          />
                        </div>
                      </Col>
                      <Col xs={12} sm={6} lg={6}>
                        <label
                          className="fw-bold"
                          style={{ fontSize: "1rem" }}
                        >
                          Last Name *
                        </label>
                        <div className="d-flex flex-column">
                          <input
                            style={{ width: "100%", height: "auto" }}
                            className="form-control rounded-0"
                            onChange={handleInputChange}
                            value={formData.surName}
                            name="surName"
                            type="text"
                            maxLength={30}
                            required
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="my-4">
                    <Row>
                      <Col xs={12} sm={6} lg={6}>
                        <div>
                          <label
                            className="fw-bold"
                            style={{ fontSize: "1rem" }}
                          >
                            Professional Category *
                          </label>
                          <div className="d-flex flex-column">
                            <select
                              className="form-control rounded-0"
                              required
                              value={formData.businessCategory}
                              onChange={handleInputChange}
                              name="businessCategory"
                            >
                              <option value="">Select category...</option>
                              {Profession.map((data, index) => (
                                <option key={index} value={data}>
                                  {data}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} sm={6} lg={6}>
                        <label
                          className="fw-bold"
                          style={{ fontSize: "1rem" }}
                        >
                          Role *
                        </label>
                        <div className="d-flex flex-column">
                          <select
                            className="form-control rounded-0"
                            required
                            value={formData.role}
                            onChange={handleInputChange}
                            name="role"
                          >
                            <option value="">Select role...</option>
                            {role.map((data, index) => (
                              <option key={index} value={data}>
                                {data}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="my-4">
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <label
                          className="fw-bold"
                          style={{ fontSize: "1rem" }}
                        >
                          Address 1 *{" "}
                        </label>
                        <div className="d-flex flex-column">
                          <input
                            style={{ width: "100%", height: "auto" }}
                            className="form-control rounded-0"
                            onChange={handleInputChange}
                            value={formData.address1}
                            name="address1"
                            type="text"
                            maxLength={50}
                            required
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="my-4">
                    <Row>
                      <Col xs={12} sm={6} lg={6}>
                        <label
                          className="fw-bold"
                          style={{ fontSize: "1rem" }}
                        >
                          Address 2 *
                        </label>
                        <div className="d-flex flex-column">
                          <input
                            style={{ width: "100%", height: "auto" }}
                            className="form-control rounded-0"
                            onChange={handleInputChange}
                            value={formData.address2}
                            name="address2"
                            type="text"
                            maxLength={40}
                            required
                          />
                        </div>
                      </Col>
                      <Col xs={12} sm={6} lg={6}>
                        <label
                          className="fw-bold"
                          style={{ fontSize: "1rem" }}
                        >
                          Country *
                        </label>
                        <div className="d-flex flex-column">
                          <select
                            className="form-control rounded-0"
                            required
                            value={formData.country}
                            onChange={handleInputChange}
                            name="country"
                          >
                            <option value="">Select country...</option>
                            {country_list.map((data, index) => (
                              <option key={index} value={data}>
                                {data}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="my-4">
                    <Row>
                      <Col xs={12} sm={6} lg={6}>
                        <label
                          className="fw-bold"
                          style={{ fontSize: "1rem" }}
                        >
                          City *
                        </label>
                        <div className="d-flex flex-column">
                          <input
                            style={{ width: "100%", height: "auto" }}
                            className="form-control rounded-0"
                            onChange={handleInputChange}
                            value={formData.city}
                            name="city"
                            type="text"
                            maxLength={30}
                            required
                          />
                        </div>
                      </Col>

                      <Col xs={6} sm={6} lg={3}>
                        <label
                          className="fw-bold"
                          style={{ fontSize: "1rem" }}
                        >
                          State *
                        </label>
                        <div className="d-flex flex-column">
                          <input
                            style={{ width: "100%", height: "auto" }}
                            className="form-control rounded-0"
                            onChange={handleInputChange}
                            value={formData.state}
                            name="state"
                            type="text"
                            maxLength={30}
                            required
                          />
                        </div>
                      </Col>
                      <Col xs={6} sm={6} lg={3}>
                        <label
                          className="fw-bold"
                          style={{ fontSize: "1rem" }}
                        >
                          Pincode *
                        </label>
                        <div className="d-flex flex-column">
                          <input
                            style={{ width: "100%", height: "auto" }}
                            className="form-control rounded-0"
                            onChange={handleInputChange}
                            value={formData.pinCode}
                            name="pinCode"
                            type="text"
                            minLength={3}
                            maxLength={10}
                            required
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="my-4">
                    <Row>
                      <Col xs={12} sm={6} lg={6}>
                        <label
                          className="fw-bold"
                          style={{ fontSize: "1rem" }}
                        >
                          Phone No *
                        </label>
                        <div className="d-flex flex-column">
                          <input
                            style={{ width: "100%", height: "auto" }}
                            className="form-control rounded-0"
                            onChange={handleInputChange}
                            value={formData.phoneNo}
                            name="phoneNo"
                            type="text"
                            maxLength={15}
                            required
                          />
                        </div>
                      </Col>
                      <Col xs={12} sm={6} lg={6}>
                        <label
                          className="fw-bold"
                          style={{ fontSize: "1rem" }}
                        >
                          Telephone
                        </label>
                        <div className="d-flex flex-column">
                          <input
                            style={{ width: "100%", height: "auto" }}
                            className="form-control rounded-0"
                            onChange={handleInputChange}
                            value={formData.telephoneNo}
                            name="telephoneNo"
                            type="text"
                            maxLength={15}
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="my-4">
                    <Row>
                      <Col xs={12} sm={6} lg={6}>
                        <label
                          className="fw-bold text-nowrap"
                          style={{ fontSize: "1rem" }}
                        >
                          Registration No *
                          <OverlayTrigger
                            placement="bottom"
                            overlay={<Tooltip id="button-tooltip-2">Enter Number of your Law firm Registration in bar association of your country.</Tooltip>}
                          >
                            {({ ref, ...triggerHandler }) => (
                              <Button
                                variant="light"
                                {...triggerHandler}
                                className="d-inline-flex align-items-center p-0"
                                style={{ backgroundColor: 'transparent', border: 'none' }}
                              >
                                <Image ref={ref}
                                  roundedCircle src={infoImg} style={{ height: "4vh", filter: "invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)" }} />
                              </Button>
                            )}
                          </OverlayTrigger>
                        </label>
                        <input
                          style={{ height: "auto" }}
                          className="form-control rounded-0"
                          onChange={handleInputChange}
                          value={formData.inputNumber}
                          name="inputNumber"
                          type="text"
                          maxLength={30}
                          required
                        />
                      </Col>
                      <Col xs={12} sm={6} lg={6}>
                        <label
                          className="fw-bold"
                          style={{ fontSize: "1rem" }}
                        >
                          Collaboration No *

                          <OverlayTrigger
                            placement="bottom"
                            overlay={<Tooltip id="button-tooltip-2">Please Refer to AECCI Collaboration Agreement Reference number</Tooltip>}
                          >
                            {({ ref, ...triggerHandler }) => (
                              <Button
                                variant="light"
                                {...triggerHandler}
                                className="d-inline-flex align-items-center p-0"
                                style={{ backgroundColor: 'transparent', border: 'none' }}
                              >
                                <Image ref={ref}
                                  roundedCircle src={infoImg} style={{ height: "4vh", filter: "invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)" }} />
                              </Button>
                            )}
                          </OverlayTrigger>
                        </label>
                        <input
                          style={{ height: "auto" }}
                          className="form-control rounded-0"
                          onChange={handleInputChange}
                          value={formData.gstNo}
                          name="gstNo"
                          type="text"
                          minLength={5}
                          maxLength={30}
                          required
                        />
                      </Col>
                    </Row>
                  </div>

                  <div className="d-flex  justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-start gap-2 text-white">
                      <LoadCanvasTemplate className="text-white" />
                      {isCaptchaCorrect && (
                        <AiFillCheckCircle className="icon-size text-success" />
                      )}{" "}
                    </div>

                    <div className="w-50">
                      <input
                        className="w-100 px-2 py-1 border-1"
                        placeholder="Type the given captcha word"
                        id="user_captcha_input"
                        name="user_captcha_input"
                        type="text"
                        maxLength={captcha_length}
                        onChange={handleCaptchaChange}
                        value={captchaValue}
                      />
                      {isCaptchaCorrect ? (
                        <p className="text-success">CAPTCHA is valid</p>
                      ) : (
                        <p className="text-danger">CAPTCHA is invalid</p>
                      )}
                    </div>
                  </div>
                  <div className="my-4">
                    <Form.Group className="mb-3">
                      <Form.Check
                        ref={checkboxRef}
                        required
                        checked={isChecked}
                        onChange={(e) => setIsChecked(e.target.checked)}
                        label={
                          <span className='text-white' style={{ fontSize: '1em' }}>
                            I agree to the{' '}
                            <a href="#" onClick={handleShow} style={{ textDecoration: 'underline' }}>
                              Terms and Conditions
                            </a>{' '}
                            and{' '}
                            <a href="#" onClick={handleShowFaq} style={{ textDecoration: 'underline' }}>
                              Read our FAQs
                            </a>
                          </span>
                        }
                        feedback="You must agree before submitting."
                        feedbackType="invalid"
                      />
                    </Form.Group>

                    {/* Modal for Terms and Conditions */}
                    <Modal show={showModal} onHide={handleClose} size="lg" centered>
                      <Modal.Header closeButton>
                        <Modal.Title>Terms & Conditions for Collaborators</Modal.Title>
                      </Modal.Header>
                      <Modal.Body style={{ maxHeight: "400px", overflowY: "auto" }}>
                        <p><strong>1. Introductory Session:</strong> The first session arranged by AECCI with each business participant is introductory in nature and is kept free of charge.</p>

                        <p><strong>2. Purpose of the Virtual B2B Forum:</strong> This Virtual B2B Forum provides you the opportunity to connect with business participants that could potentially become valuable future clients for your firm.</p>

                        <p><strong>3. Scope of the Session:</strong> The session is intended to address basic trade queries raised by the business participant, including topics such as target market information, customer preferences, legal matters like contract drafting, regulations and compliance, trade disputes, intellectual property rights (IPR) issues, etc.</p>

                        <p><strong>4. Advisory Role:</strong> During the session, collaborators may offer guidance on the trade queries raised by the business participants, exhibiting their trade knowledge and expertise in the international market.</p>

                        <p><strong>5. Services:</strong> For more detailed queries or specific services, collaborators can offer further assistance to business participants on a reasonable charge while sharing the terms and conditions in advance.</p>

                        <p><strong>6. Preparation for the Session:</strong> To make the most of the 30-minute session, we recommend that collaborators thoroughly review the business participant’s profile and industry beforehand. This will ensure addressing sector-specific queries effectively.</p>

                        <p><strong>7. Mutual Understanding:</strong> Both parties should use this session as an opportunity to understand each other’s capabilities and explore potential services. It is encouraged to discuss the scope, terms, and fees for any future services.</p>

                        <p><strong>8. One-to-One Session:</strong> The session will be conducted as a one-to-one interaction between the expert collaborator and the business participant, with no interference from AECCI. Our role is to provide the connection and platform while ensuring the privacy of both parties’ business information.</p>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" size="sm" onClick={handleClose}>
                          Close
                        </Button>
                        <Button variant="primary" size="sm" onClick={handleAgree}>
                          Agree
                        </Button>
                      </Modal.Footer>
                    </Modal>



                    {/* Modal for FAQ */}
                    <Modal show={showFaqModal} onHide={handleCloseFaq} size="xl" centered>
                      <Modal.Header closeButton style={{ borderBottom: "2px solid #ddd", padding: "15px 20px" }}>
                        <Modal.Title style={{ fontSize: "1.5rem", color: "#333" }}>
                          FAQs for Collaborators
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body style={{ maxHeight: '500px', overflowY: 'auto', padding: "20px" }}>
                        <div style={{ fontFamily: "Arial, sans-serif", lineHeight: "1.8", fontSize: "1rem", color: "#333" }}>

                          {/* General Section */}
                          <h4 style={{ color: "#2c3e50", marginBottom: "15px", fontWeight: "bold" }}>General</h4>
                          <Accordion flush>
                            <Accordion.Item eventKey="1">
                              <Accordion.Header>
                                <strong>What is Virtual B2B Forum?</strong>
                              </Accordion.Header>
                              <Accordion.Body>
                                The Virtual B2B Forum is an online platform designed to connect Indian businesseThe Virtual B2B Forum is an online platform designed to connect Indian businesses and expert collaborators from around the world, facilitating meaningful business discussions and opportunities for both the sides.s and expert collaborators from around the world, facilitating meaningful business discussions and opportunities for both sides.
                              </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="2">
                              <Accordion.Header>
                                <strong>What is the mission of the Virtual B2B Forum?</strong>
                              </Accordion.Header>
                              <Accordion.Body>
                                The mission of the Virtual B2B Forum is to strengthen business connections between expert collaborators and Indian businesses, thus strengthening international trade ties and helping both sides to expand their reach globally.
                                <br />
                                Our Virtual B2B Forum is meant to facilitate the access to international collaborators through introductory interactive sessions and without involving financial investment.
                              </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="3">
                              <Accordion.Header>
                                <strong>What are the general trade queries and service requirements of B2B business participants?</strong>
                              </Accordion.Header>
                              <Accordion.Body>
                                The primary goal for most businesses participating in these meetings is to seek guidance on business expansion. Our participants, ranging from new to established businesses, often have queries related to entering new markets, expanding within those markets, understanding regulatory or compliance requirements, and addressing legal matters such as contract drafting, trade disputes, and intellectual property rights (IPR) issues. They may also inquire about investment opportunities between countries.
                                <br />
                                We highly recommend exchanging business cards during the first meeting to foster future connections, allowing both parties to benefit from potential collaborations down the line.
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>

                          <hr style={{ borderTop: "2px solid #ddd", margin: "25px 0" }} />

                          {/* Business Opportunities Section */}
                          <h4 style={{ color: "#2c3e50", marginBottom: "15px", fontWeight: "bold" }}>Business Opportunities</h4>
                          <Accordion flush>
                            <Accordion.Item eventKey="4">
                              <Accordion.Header>
                                <strong>How are the business participants selected for the B2B platform?</strong>
                              </Accordion.Header>
                              <Accordion.Body>
                                Business participants in our B2B sessions are primarily our registered trade members who seek our assistance with their business and shipment-related services. As part of the registration process, we collect their profile information and authentication documents. Based on this, we invite qualified members to participate in our B2B meetings, ensuring they are the right participants for the platform.
                              </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="5">
                              <Accordion.Header>
                                <strong>How do you keep things discreet?</strong>
                              </Accordion.Header>
                              <Accordion.Body>
                                We understand the sensitivity of the information we handle and take every possible measure to maintain its confidentiality. Before onboarding any participant or collaborator, we follow a thorough process that includes discussion, application, reviewing their profile and relevant documents. Only after this due diligence and signing the agreement, we gain the confidence to bring them on board for B2B sessions.
                              </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="6">
                              <Accordion.Header>
                                <strong>How do you decide whether or not to approve a B2B meeting request?</strong>
                              </Accordion.Header>
                              <Accordion.Body>
                                Each meeting request is carefully reviewed to identify the seriousness of businesses so that to extend maximum benefit from the opportunities offered by the Virtual B2B Forum. Incomplete application or wrong information on B2B platform may lead to rejection of meeting request.
                              </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="7">
                              <Accordion.Header>
                                <strong>Who is responsible for controlling the B2B Sessions?</strong>
                              </Accordion.Header>
                              <Accordion.Body>
                                All B2B Sessions facilitated through our Virtual B2B Forum are managed and monitored by our B2B team. While we do not directly participate in the discussions between experts and business participants, team remains actively available throughout the meeting. B2B team keeps ready to provide any technical or other support needed to ensure the meeting runs smoothly and according to the given schedule.
                              </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="8">
                              <Accordion.Header>
                                <strong>How do I get an update on the status of my B2B Sessions?</strong>
                              </Accordion.Header>
                              <Accordion.Body>
                                Our Virtual B2B platform is designed for the convenience of both parties. Expert collaborators can provide multiple available time slots directly on the platform, and Indian participants can request for appointments based on the available options. <br /> All details regarding your meeting schedule or other updates, will be available in your digital account on our platform.

                              </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="9">
                              <Accordion.Header>
                                <strong>How much time is generally available for each session and for discussing business?</strong>
                              </Accordion.Header>
                              <Accordion.Body>
                                Each meeting on our Virtual B2B Forum is allocated a 30-minute slot. Video conferencing windows are opened in advance for audio-video testing, and the remaining 30 minutes are dedicated to discussion. <br /> We encourage our collaborative partners to address as many queries as possible during this first introductory session, with the goal of building strong relationships and in order to secure potential future clients.
                              </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="10">
                              <Accordion.Header>
                                <strong>How can I prepare to get the maximum outcome from the B2B Sessions? </strong>
                              </Accordion.Header>
                              <Accordion.Body>
                                We insist our business participants to share their profile and probable points of discussion in advance so that the expert collaborator can keep ready to handle the relevant queries. Additionally, exchanging business cards at the end of the meeting is a great way to establish future connections and strengthen ongoing business relationships.
                              </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="11">
                              <Accordion.Header>
                                <strong>I couldn’t find any appointment requests for my country on the B2B platform. What can I do about it?</strong>
                              </Accordion.Header>
                              <Accordion.Body>
                                If there are fewer or no B2B session requests for your country on the platform, we can increase visibility by advertising your profile.
                                <br />
                                Additionally, we can schedule a webinar or an "Ask Me Anything" session with you, which will help us to introduce you to our trade members and generate future connections.
                              </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="12">
                              <Accordion.Header>
                                <strong>What happens if the other side doesn’t want to cooperate during the B2B Session?</strong>
                              </Accordion.Header>
                              <Accordion.Body>
                                Although such situations are rare, if you come across such a business participant who is showing disinterest, it may be due to a language barrier or technical issues on other side. In such cases, please send us your feedback. <br /> We will follow up with the business participant and, if necessary, will facilitate written communication (via email) between both parties to address any concerns.
                              </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="13">
                              <Accordion.Header>
                                <strong>I’ve changed my mind and no longer wish to continue with the scheduled B2B Session. Can I request to change the schedule?</strong>
                              </Accordion.Header>
                              <Accordion.Body>
                                If the session has not yet been confirmed by the business participant, you can certainly make the changes according to your availability. However, if the meeting has already been confirmed, it may be little difficult to make changes. In that case, please inform us directly, and we will do our best to work with the business participant to reschedule the session.
                              </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="14">
                              <Accordion.Header>
                                <strong>What happens if my B2B Sessions didn’t succeed?</strong>
                              </Accordion.Header>
                              <Accordion.Body>
                                While we make every effort to ensure successful sessions, there are times when outcomes may not meet expectations due to factors beyond our control. We recommend exchanging business cards with your business participant so you can explore further opportunities at a later time.
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                          <div>
                            <h4 style={{ color: "#2c3e50", marginBottom: "15px", fontWeight: "bold" }} className='mt-4'>
                              Team Members
                            </h4>
                            <hr style={{ borderTop: "2px solid #ddd", marginBottom: "20px" }} />
                            <ContactTable />
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer style={{ borderTop: "2px solid #ddd", padding: "15px 20px" }}>
                        <Button variant="secondary" size="sm" onClick={handleCloseFaq} >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </div>
                  <div className="d-flex justify-content-between">
                    <Button
                      variant="danger"
                      size="sm"
                      className="px-5 py-2 rounded-1 border-0 fw-medium"
                      onClick={resetForm}
                    >
                      Reset
                    </Button>
                    <Button
                      type="submit"
                      size="sm"
                      className="px-5 py-2 rounded-1 border-0 fw-medium"
                      disabled={registerFormSuccess}
                    >
                      {!registerFormSuccess ? "Register" : "Processing..."}
                    </Button>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
          <hr />
          <div className="d-none d-md-block">
            <OurPresence />
          </div>
        </div>
      </Layout>
    </>
  );
};

export default CollaborationSignup;
